// React
import React from 'react';

// Vendors
import { Alert, Snackbar as MuiSnackBar } from '@mui/material';
import { useDispatch } from 'react-redux';

// Src
import { removeMessageAction } from '@/infrastructure/redux/clientState/snackBarReducer';
import { useAppSelector } from '@/infrastructure/redux/hooks/useAppSelector';

// Styles
import classes from './SnackBar.module.scss';

const SnackBar = (): JSX.Element => {
    // Hooks
    const dispatch = useDispatch();
    const snackBarState = useAppSelector((state) => state.snackBarReducer);

    // Variables
    const messages = snackBarState.messages;

    // Handlers
    const handleClose = (id: number) => {
        dispatch(removeMessageAction(id));
    };

    return (
        <>
            {messages.map((message, index) => (
                <MuiSnackBar
                    key={message.id}
                    open={true}
                    autoHideDuration={6000}
                    onClose={() => handleClose(message.id)}
                    anchorOrigin={{
                        horizontal: 'right',
                        vertical: 'bottom',
                    }}
                    style={{
                        marginBottom: `${index * 64}px`,
                    }}
                    className={classes.SnackBar}
                >
                    <Alert
                        severity={message.type}
                        variant="filled"
                    >
                        {message.content}
                    </Alert>
                </MuiSnackBar>
            ))}
        </>
    );
};
export default SnackBar;
